import api from "utils/axios";

export async function getApplications(page = 1, limit = 10, searchTerm = "", sortOption = "newToOld", statusFilter = "all") {
  try {
    console.log("getApplications called with:", { page, limit, searchTerm, sortOption, statusFilter });

    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/jobs/get-applications`, {
      params: { page, limit, searchTerm, sort: sortOption, statusFilter },
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get job details");
    }

    const applicationData = data.data;
    const pagination = applicationData.pagination || {};
    const applications = applicationData.applications || [];

    return {
      applications,
      pagination
    };
  } catch (error) {
    console.error("getApplications error:", error);
    return { applications: [], pagination: null };
  }
}

export async function changeApplicationStatus(applicationId, status) {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/jobs/change-application-status`,
      { applicationId, status }
    );
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to change application status");
    }
    return data;
  } catch (error) {
    console.error("changeApplicationStatus error:", error);
    throw error;
  }
}

export async function deleteApplication(applicationId) {
  try {
    const { data } = await api.delete(`${process.env.REACT_APP_BASE_URL}/jobs/delete-application/${applicationId}`);
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to delete application");
    }
    return data;
  } catch (error) {
    console.error("deleteApplication error:", error);
    throw error;
  }
}
